// packages/content/src/tuning/items.ts (M1-T01, §7.2) — stack sizes are NOT here (CatalogEntry.stack, §3.1)
import type { TuningBank } from '../schema/tuning';
export default { pocketSlots: 20, storageSlots: 80, moveInItems: ['tool.rod'] } as const satisfies TuningBank;
